import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Feliz_Router_Router__Router_formatQueryAndPath_Static_Z6D0E1C21, ProjectPage__get_UrlSegments, ProjectPage, Page, Page_$reflection } from "./ClientTypes.fs.js";
import { union_type, record_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FSharpMap__ContainsKey } from "./fable_modules/fable-library-js.4.24.0/Map.js";
import { ofArray, singleton, tail as tail_2, head, isEmpty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { DomainEntities_tryParse_Z721C83C5 } from "./DomainEvents.fs.js";
import { Feliz_Router_Router__Router_getParsedUrl_Static_Z384F8060, Feliz_Router_Router__Router_getCurrentUrl_Static, System_Guid__Guid_tryParse_Static_Z721C83C5 } from "./Prelude.fs.js";
import { Route_$007CGuid$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Cmd_OfPromise_perform, Cmd_none } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { handleAuthRedirect } from "./Api/Auth.fs.js";
import { some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { isNullOrEmpty } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { Uri } from "./fable_modules/fable-library-js.4.24.0/Uri.js";
import { createObj, defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useFeliz_React__React_useMediaQuery_Static_Z721C83C5 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { RouterModule_router } from "./fable_modules/Feliz.Router.4.0.0/./Router.fs.js";
import { singleton as singleton_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { Project } from "./Project/Project.fs.js";
import { Projects } from "./Projects/Projects.fs.js";
import { Context_RouterContext } from "./hooks/UseRouter.fs.js";

export class State extends Record {
    constructor(CurrentPage, Url, Query) {
        super();
        this.CurrentPage = CurrentPage;
        this.Url = Url;
        this.Query = Query;
    }
}

export function State_$reflection() {
    return record_type("EPM.App.Index.State", [], State, () => [["CurrentPage", Page_$reflection()], ["Url", string_type], ["Query", string_type]]);
}

function parseUrl(url, query) {
    if (FSharpMap__ContainsKey(query, "code")) {
        return new Page(3, []);
    }
    else if (!isEmpty(url)) {
        if (head(url) === "projects") {
            let matchResult, projectId;
            if (!isEmpty(tail_2(url))) {
                const activePatternResult = Route_$007CGuid$007C_$007C(head(tail_2(url)));
                if (activePatternResult != null) {
                    if (isEmpty(tail_2(tail_2(url)))) {
                        matchResult = 0;
                        projectId = activePatternResult;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new Page(1, [new ProjectPage(0, [projectId])]);
                default: {
                    let matchResult_1, projectId_1, tail_1;
                    if (!isEmpty(tail_2(url))) {
                        const activePatternResult_1 = Route_$007CGuid$007C_$007C(head(tail_2(url)));
                        if (activePatternResult_1 != null) {
                            matchResult_1 = 0;
                            projectId_1 = activePatternResult_1;
                            tail_1 = tail_2(tail_2(url));
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            let matchResult_2, modelId, adminPage, entityId, entityType;
                            if (!isEmpty(tail_1)) {
                                switch (head(tail_1)) {
                                    case "definition": {
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 5;
                                                entityId = head(tail_2(tail_1));
                                                entityType = head(tail_1);
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 0;
                                        }
                                        break;
                                    }
                                    case "dashboard": {
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 5;
                                                entityId = head(tail_2(tail_1));
                                                entityType = head(tail_1);
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 1;
                                        }
                                        break;
                                    }
                                    case "progress": {
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 5;
                                                entityId = head(tail_2(tail_1));
                                                entityType = head(tail_1);
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 2;
                                        }
                                        break;
                                    }
                                    case "model": {
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 3;
                                                modelId = head(tail_2(tail_1));
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 6;
                                        }
                                        break;
                                    }
                                    case "admin": {
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 4;
                                                adminPage = head(tail_2(tail_1));
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 6;
                                        }
                                        break;
                                    }
                                    default:
                                        if (!isEmpty(tail_2(tail_1))) {
                                            if (isEmpty(tail_2(tail_2(tail_1)))) {
                                                matchResult_2 = 5;
                                                entityId = head(tail_2(tail_1));
                                                entityType = head(tail_1);
                                            }
                                            else {
                                                matchResult_2 = 6;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 6;
                                        }
                                }
                            }
                            else {
                                matchResult_2 = 6;
                            }
                            switch (matchResult_2) {
                                case 0:
                                    return new Page(1, [new ProjectPage(1, [projectId_1])]);
                                case 1:
                                    return new Page(1, [new ProjectPage(2, [projectId_1])]);
                                case 2:
                                    return new Page(1, [new ProjectPage(3, [projectId_1])]);
                                case 3:
                                    return new Page(1, [new ProjectPage(4, [projectId_1, modelId])]);
                                case 4: {
                                    const pageOpt = (adminPage === "job") ? "job" : ((adminPage === "action") ? "action" : ((adminPage === "actionType") ? "actionType" : ((adminPage === "activity") ? "activity" : ((adminPage === "certificate") ? "certificate" : ((adminPage === "documentTracking") ? "documentTracking" : ((adminPage === "preservation") ? "preservation" : ((adminPage === "punchList") ? "punchList" : ((adminPage === "technicalQuery") ? "technicalQuery" : ((adminPage === "area") ? "area" : ((adminPage === "document") ? "document" : ((adminPage === "discipline") ? "discipline" : ((adminPage === "equipmentType") ? "equipmentType" : ((adminPage === "facility") ? "facility" : ((adminPage === "location") ? "location" : ((adminPage === "module") ? "module" : ((adminPage === "productionUnit") ? "productionUnit" : ((adminPage === "productionUnitType") ? "productionUnitType" : ((adminPage === "subsystem") ? "subsystem" : ((adminPage === "system") ? "system" : ((adminPage === "tag") ? "tag" : ((adminPage === "user") ? "user" : undefined)))))))))))))))))))));
                                    if (pageOpt == null) {
                                        return new Page(2, []);
                                    }
                                    else {
                                        return new Page(1, [new ProjectPage(5, [projectId_1, pageOpt])]);
                                    }
                                }
                                case 5: {
                                    const matchValue = DomainEntities_tryParse_Z721C83C5(entityType);
                                    const matchValue_1 = System_Guid__Guid_tryParse_Static_Z721C83C5(entityId);
                                    let matchResult_3, entityId_1, entityType_1;
                                    if (matchValue != null) {
                                        if (matchValue_1 != null) {
                                            matchResult_3 = 0;
                                            entityId_1 = matchValue_1;
                                            entityType_1 = matchValue;
                                        }
                                        else {
                                            matchResult_3 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_3 = 1;
                                    }
                                    switch (matchResult_3) {
                                        case 0:
                                            return new Page(1, [new ProjectPage(6, [projectId_1, entityId_1, entityType_1])]);
                                        default:
                                            return new Page(2, []);
                                    }
                                }
                                default:
                                    return new Page(2, []);
                            }
                        }
                        default:
                            return new Page(2, []);
                    }
                }
            }
        }
        else {
            return new Page(2, []);
        }
    }
    else {
        return new Page(0, []);
    }
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UrlChanged", "AuthComplete"];
    }
}

export function Msg_$reflection() {
    return union_type("EPM.App.Index.Msg", [], Msg, () => [[["url", string_type], ["query", string_type]], []]);
}

export function init() {
    let project, patternInput_1, newUrl;
    const patternInput = Feliz_Router_Router__Router_getCurrentUrl_Static();
    const url = patternInput[0];
    const query = patternInput[1];
    let page;
    const tupledArg = Feliz_Router_Router__Router_getParsedUrl_Static_Z384F8060(url, query);
    page = parseUrl(tupledArg[0], tupledArg[1]);
    return [new State(page, url, query), (page.tag === 3) ? singleton((dispatch) => {
        dispatch(new Msg(1, []));
    }) : ((page.tag === 1) ? ((project = page.fields[0], (project.tag === 6) ? ((patternInput_1 = ProjectPage__get_UrlSegments(project), (newUrl = Feliz_Router_Router__Router_formatQueryAndPath_Static_Z6D0E1C21(patternInput_1[0], patternInput_1[1], true), (window.location.replace(newUrl), Cmd_none())))) : Cmd_none())) : Cmd_none())];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        let promise;
        const pr = handleAuthRedirect();
        promise = (pr.then((redirectUrl) => {
            console.log(some("Auth callback handled, redirect to:"), redirectUrl);
            let finalPath;
            if (isNullOrEmpty(redirectUrl)) {
                finalPath = "/";
            }
            else if (redirectUrl.startsWith("http")) {
                const uri = Uri.create(redirectUrl);
                finalPath = uri.absolutePath;
            }
            else {
                finalPath = redirectUrl;
            }
            window.history.replaceState(defaultOf(), "", finalPath);
            return new Msg(0, [finalPath, ""]);
        }));
        return [state, Cmd_OfPromise_perform(() => promise, undefined, (x) => x)];
    }
    else {
        const url = msg.fields[0];
        const query = msg.fields[1];
        let page;
        const tupledArg = Feliz_Router_Router__Router_getParsedUrl_Static_Z384F8060(url, query);
        page = parseUrl(tupledArg[0], tupledArg[1]);
        if (page.tag === 1) {
            const project = page.fields[0];
            if (project.tag === 6) {
                const patternInput = ProjectPage__get_UrlSegments(project);
                const newUrl = Feliz_Router_Router__Router_formatQueryAndPath_Static_Z6D0E1C21(patternInput[0], patternInput[1], true);
                window.location.replace(newUrl);
            }
        }
        return [new State(page, url, query), Cmd_none()];
    }
}

export function Index(props) {
    let elements;
    const isMobile = useFeliz_React__React_useMediaQuery_Static_Z721C83C5("(max-width: 768px)");
    const dependencies = [props.state.CurrentPage, isMobile];
    reactApi.useEffect(() => {
        document.body.classList.remove("has-navbar-fixed-top");
        document.body.classList.remove("has-navbar-fixed-bottom");
        const matchValue = props.state.CurrentPage;
        let matchResult;
        switch (matchValue.tag) {
            case 0: {
                if (isMobile) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 1: {
                if (isMobile) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 3;
        }
        switch (matchResult) {
            case 0: {
                break;
            }
            case 1: {
                document.body.classList.add("has-navbar-fixed-bottom");
                document.body.classList.add("has-navbar-fixed-top");
                break;
            }
            case 2: {
                document.body.classList.add("has-navbar-fixed-top");
                break;
            }
            case 3: {
                break;
            }
        }
    }, dependencies);
    const child = RouterModule_router(createObj(ofArray([["onUrlChanged", (_arg) => {
        let tupledArg;
        props.dispatch((tupledArg = Feliz_Router_Router__Router_getCurrentUrl_Static(), new Msg(0, [tupledArg[0], tupledArg[1]])));
    }], ["hashMode", 2], (elements = toList(delay(() => {
        const matchValue_2 = props.state.CurrentPage;
        return (matchValue_2.tag === 1) ? singleton_1(createElement(Project, {
            projectPage: matchValue_2.fields[0],
        })) : ((matchValue_2.tag === 2) ? singleton_1("not found") : ((matchValue_2.tag === 3) ? singleton_1("auth") : singleton_1(createElement(Projects, null))));
    })), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
    return reactApi.createElement(Context_RouterContext.Provider, {
        value: [props.state.Url, props.state.Query],
    }, child);
}

export function view(state, dispatch) {
    return createElement(Index, {
        dispatch: dispatch,
        state: state,
    });
}

